var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('confirm-dialog',{attrs:{"value":true,"title":"ユーザープロフィール登録のお願い","confirm-label":"入力する","cancel-label":"今は入力しない","message":"Legalscape をより快適にご利用いただくために、ユーザープロフィールのご登録をお願いしております。"},on:{"cancel":_vm.cancelHandler,"confirm":_vm.confirmHandler}})
}
var staticRenderFns = []

export { render, staticRenderFns }